var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode === 'DESIGN')?_c('div',[_vm._v(" 内联框架，显示URL页面 ")]):_c('div',[_c('iframe',{attrs:{"scrolling":"auto","frameborder":"0","src":_vm.parsingUrl,"height":_vm.height + 'px',"width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }